export default {
  blackLight: '#1a1a1a',
  dirtyWhite: 'rgba(255,255,255,0.5)',
  white: '#fff',
  black: '#000',
  darkGrey: '#333333',
  dividerColor: 'rgba(255,255,255,0.15)',
  darkerGrey: '#1A1A1A',
  red: '#f0162f',
  green: '#00b061',
};
